export var MPAListRequestSortField;
(function (MPAListRequestSortField) {
    MPAListRequestSortField["MPA_LIST_REQUEST_SORT_FIELD_CREATED_AT"] = "CREATED_AT";
})(MPAListRequestSortField || (MPAListRequestSortField = {}));
